import { goToLogin } from '../../router';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:5041';

const empresaService = (() => {
  const axios = require('axios');

  const instance = axios.create({
    baseURL: API_URL,
    withCredentials: true, // Include cookies in requests
  });

  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        goToLogin();
      }
      return Promise.reject(error);
    }
  );

  instance.interceptors.request.use(
    config => {
      const token = localStorage.getItem('jwt-token');
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  const addEmpresa = async (empresa) => {
    try {
      const response = await instance.post('/Tenant', empresa);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };
   
  const getAllEmpresa = async () => {
    try {
      const response = await instance.get('/Tenant');
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const getById = async (id) => {
    try {
      const response = await instance.get(`/Tenant/${id}`);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const editEmpresa = async (id, empresa) => {
    try {
      const response = await instance.put(`/Tenant/${id}`, empresa);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const removeEmpresa = async (id) => {
    try {
      const response = await instance.delete(`/Tenant/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar empresa:', error);
      if (error.response) {
        throw new Error(error.response.data?.message || `Error ${error.response.status}: No se pudo eliminar la empresa`);
      }
      throw error;
    }
  };

  const toggleEmpresaStatus = async (id, isActive) => {
    try {
      // Intentar usar endpoint específico si existe
      const response = await instance.patch(`/Tenant/${id}/status`, { isActive });
      return response.data;
    } catch (error) {
      // Si no existe el endpoint, actualizar usando PUT
      console.log('Usando método alternativo para cambiar estado');
      try {
        const empresa = await getById(id);
        if (empresa) {
          empresa.isActive = isActive;
          return await editEmpresa(id, empresa);
        }
      } catch (innerError) {
        console.log(innerError);
      }
      return null;
    }
  };

  return {
    addEmpresa,
    getAllEmpresa,
    getById,
    editEmpresa,
    removeEmpresa,
    toggleEmpresaStatus
  };
})();

export default empresaService;
